module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c Blue.70fb3dca.png";